//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    bgColor: {
      type: String,
      default: null
    },
    showTop: {
      type: Boolean,
      default: false
    },
    colored: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    steps: {
      type: Array,
      default: null
    },
    imgs: {
      type: Array,
      default: null
    },
    cols: {
      type: Number,
      default: null
    },
    lgImgs: {
      type: Array,
      default: null
    }
  }
}
